import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type StickyNote2Props = IconComponentBaseProps;

export const StickyNote2 = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: StickyNote2Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_4893_12849"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill={fill} />
      </mask>
      <g mask="url(#mask0_4893_12849)">
        <path
          d="M4.42345 15.8332H11.667V12.4196C11.667 12.2063 11.7391 12.0274 11.8835 11.883C12.0279 11.7387 12.2068 11.6665 12.4201 11.6665H15.8337V4.42296C15.8337 4.3481 15.8096 4.28664 15.7616 4.23859C15.7135 4.19053 15.6521 4.1665 15.5772 4.1665H4.42345C4.34859 4.1665 4.28713 4.19053 4.23908 4.23859C4.19102 4.28664 4.16699 4.3481 4.16699 4.42296V15.5767C4.16699 15.6516 4.19102 15.713 4.23908 15.7611C4.28713 15.8091 4.34859 15.8332 4.42345 15.8332ZM4.42345 17.0832C4.00914 17.0832 3.65449 16.9357 3.35949 16.6407C3.06449 16.3457 2.91699 15.991 2.91699 15.5767V4.42296C2.91699 4.00866 3.06449 3.654 3.35949 3.359C3.65449 3.064 4.00914 2.9165 4.42345 2.9165H15.5772C15.9915 2.9165 16.3462 3.064 16.6412 3.359C16.9362 3.654 17.0837 4.00866 17.0837 4.42296V11.58C17.0837 11.7832 17.0446 11.9769 16.9666 12.1611C16.8887 12.3453 16.7813 12.5057 16.6445 12.6423L12.6428 16.644C12.5062 16.7808 12.3457 16.8882 12.1616 16.9661C11.9774 17.0441 11.7837 17.0832 11.5805 17.0832H4.42345ZM9.37533 11.4421H6.8272C6.65012 11.4421 6.50171 11.3822 6.38199 11.2623C6.26213 11.1425 6.2022 10.994 6.2022 10.8169C6.2022 10.6397 6.26213 10.4913 6.38199 10.3717C6.50171 10.252 6.65012 10.1921 6.8272 10.1921H9.37533C9.55241 10.1921 9.70088 10.2521 9.82074 10.3719C9.94046 10.4918 10.0003 10.6403 10.0003 10.8173C10.0003 10.9946 9.94046 11.143 9.82074 11.2625C9.70088 11.3823 9.55241 11.4421 9.37533 11.4421ZM13.1735 8.12484H6.8272C6.65012 8.12484 6.50171 8.06491 6.38199 7.94505C6.26213 7.82518 6.2022 7.67671 6.2022 7.49963C6.2022 7.32241 6.26213 7.174 6.38199 7.05442C6.50171 6.9347 6.65012 6.87484 6.8272 6.87484H13.1735C13.3505 6.87484 13.4989 6.93477 13.6187 7.05463C13.7385 7.17449 13.7985 7.32296 13.7985 7.50005C13.7985 7.67727 13.7385 7.82567 13.6187 7.94525C13.4989 8.06498 13.3505 8.12484 13.1735 8.12484Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
